export type CreateInterfaceDeploymentRequestResponse = {
  warningMessage: string[] | null;
};
